<template>
  <div class="modern-login-container">
    <div class="login-card" :class="{ 'no-illustration': hideIllustration }">
      <!-- Lado Esquerdo - Formulário -->
      <div class="form-section">
        <div class="form-content">
          <div class="logo-section">
            <h1 class="app-title">Selo Sebrae de Referência em Atendimento</h1>
            <p class="app-subtitle">
              Acesse sua conta para continuar sua jornada de excelência
            </p>
          </div>

          <div class="form-wrapper">
            <slot name="formulario"></slot>
          </div>
        </div>
      </div>

      <!-- Lado Direito - Ilustração -->
      <div class="illustration-section" v-if="!hideIllustration">
        <div class="illustration-content">
          <!-- Cenário da cidade -->
          <div class="city-scene">
            <div class="city-skyline">
              <div class="building building-1"></div>
              <div class="building building-2"></div>
              <div class="building building-3"></div>
              <div class="building building-4"></div>
              <div class="building building-5"></div>
            </div>

            <!-- Elementos decorativos -->
            <div class="city-elements">
              <div class="cloud cloud-1"></div>
              <div class="cloud cloud-2"></div>
              <div class="sun"></div>
            </div>
          </div>

          <!-- Sistema de Medalhas -->
          <div class="medals-system">
            <!-- Medalha Principal - Diamante -->
            <div class="diamond-tier">
              <div class="medal-item diamond-medal premium">
                <div class="medal-circle diamond diamond-glow">
                  <img
                    src="https://slide1-images.s3.amazonaws.com/public/selo-medalha/seloMedalhaDiamante2026.png"
                    alt="Medalha Diamante"
                    class="medal-image diamond-image"
                  />
                </div>
                <span class="medal-label diamond-label">Diamante</span>
                <span class="medal-subtitle">Excelência Máxima</span>
              </div>
            </div>

            <!-- Indicador de Progressão -->
            <div class="progression-arrow">
              <div class="arrow-up">↗</div>
            </div>

            <!-- Medalhas Intermediárias -->
            <div class="medals-progression">
              <div class="medal-item bronze-medal">
                <div class="medal-circle bronze">
                  <img
                    src="https://slide1-images.s3.amazonaws.com/public/selo-medalha/seloMedalhaBronze2026.png"
                    alt="Medalha Bronze"
                    class="medal-image"
                  />
                </div>
                <span class="medal-label">Bronze</span>
              </div>

              <div class="progression-connector">
                <div class="connector-line"></div>
                <div class="connector-arrow">→</div>
              </div>

              <div class="medal-item silver-medal">
                <div class="medal-circle silver">
                  <img
                    src="https://slide1-images.s3.amazonaws.com/public/selo-medalha/seloMedalhaPrata2026.png"
                    alt="Medalha Prata"
                    class="medal-image"
                  />
                </div>
                <span class="medal-label">Prata</span>
              </div>

              <div class="progression-connector">
                <div class="connector-line"></div>
                <div class="connector-arrow">→</div>
              </div>

              <div class="medal-item gold-medal">
                <div class="medal-circle gold">
                  <img
                    src="https://slide1-images.s3.amazonaws.com/public/selo-medalha/seloMedalhaOuro2026.png"
                    alt="Medalha Ouro"
                    class="medal-image"
                  />
                </div>
                <span class="medal-label">Ouro</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LoginSelo",
  props: {
    hideIllustration: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/variables.scss";

// Variáveis de cores
$primary-blue: #2a4fd7;
$primary-blue-light: #4a6bdb;
$primary-blue-dark: #1e3ba3;
$primary-blue-lighter: #e8f0ff;
$white: #ffffff;
$gray-50: #f9fafb;
$gray-100: #f3f4f6;
$gray-200: #e5e7eb;
$gray-600: #4b5563;
$gray-700: #374151;

// Cores das medalhas
$bronze: #cd7f32;
$bronze-light: #e6a55f;
$silver: #c0c0c0;
$silver-light: #d4d4d4;
$gold: #ffd700;
$gold-light: #ffed4e;
$diamond: #b9f2ff;
$diamond-light: #e0f8ff;

.modern-login-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  padding: 20px;
}

.login-card {
  width: 100%;
  max-width: 1200px;
  background: $white;
  border-radius: 20px;
  box-shadow: 0 25px 50px rgba(42, 79, 215, 0.15);
  display: grid;
  grid-template-columns: 1fr 1fr;
  overflow: hidden;
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 35px 60px rgba(42, 79, 215, 0.2);
  }
}

// Quando não há ilustração, ocupa toda a largura
.login-card.no-illustration {
  grid-template-columns: 1fr;
  max-width: 600px;
  justify-content: center;

  .form-section {
    padding: 60px 50px;
  }
}

// LADO ESQUERDO - FORMULÁRIO
.form-section {
  padding: 80px 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background: $white;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, $primary-blue, $primary-blue-light);
  }
}

.form-content {
  width: 100%;
  max-width: 420px;
  margin: 0 auto;
}

.logo-section {
  text-align: center;
  margin-bottom: 48px;
}

.app-title {
  font-size: 28px;
  font-weight: 700;
  color: $primary-blue;
  margin-bottom: 12px;
  line-height: 1.2;
  animation: fadeInUp 0.6s ease;
}

.app-subtitle {
  font-size: 16px;
  color: $gray-600;
  margin-bottom: 0;
  font-weight: 400;
  animation: fadeInUp 0.6s ease 0.2s both;
}

.form-wrapper {
  animation: fadeInUp 0.6s ease 0.4s both;
}

// Melhorias no espaçamento dos elementos do formulário
:deep(.form-content) {
  padding: 0 !important;
}

:deep(.v-card-text.form-content) {
  padding: 0 0 24px 0 !important;
}

// LADO DIREITO - ILUSTRAÇÃO
.illustration-section {
  background: linear-gradient(
    135deg,
    $primary-blue 0%,
    $primary-blue-light 100%
  );
  padding: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: $white;
  position: relative;
  overflow: hidden;
}

.illustration-content {
  width: 100%;
  max-width: 350px;
  text-align: center;
}

.progress-header {
  margin-bottom: 40px;
  animation: fadeInUp 0.8s ease;
}

.progress-title {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 8px;
  color: $white;
}

.progress-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  margin-bottom: 0;
}

// CENÁRIO DA CIDADE
.city-scene {
  position: relative;
  height: 100px;
  margin-bottom: 35px;
  animation: slideInRight 1s ease 0.3s both;
}

.city-skyline {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  height: 100%;
  gap: 8px;
}

.building {
  background: rgba(255, 255, 255, 0.9);
  border-radius: 4px 4px 0 0;
  position: relative;
  animation: buildingGrow 0.8s ease both;

  &::before {
    content: "";
    position: absolute;
    top: 8px;
    left: 50%;
    transform: translateX(-50%);
    width: 6px;
    height: 6px;
    background: $primary-blue;
    border-radius: 1px;
  }

  &.building-1 {
    width: 25px;
    height: 60px;
    animation-delay: 0.1s;
  }

  &.building-2 {
    width: 20px;
    height: 80px;
    animation-delay: 0.2s;
  }

  &.building-3 {
    width: 30px;
    height: 70px;
    animation-delay: 0.3s;
  }

  &.building-4 {
    width: 22px;
    height: 90px;
    animation-delay: 0.4s;
  }

  &.building-5 {
    width: 28px;
    height: 65px;
    animation-delay: 0.5s;
  }
}

.city-elements {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
}

.cloud {
  position: absolute;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 20px;
  animation: cloudFloat 3s ease-in-out infinite;

  &::before,
  &::after {
    content: "";
    position: absolute;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 50%;
  }

  &.cloud-1 {
    width: 20px;
    height: 8px;
    top: 20px;
    left: 20px;
    animation-delay: 0s;

    &::before {
      width: 12px;
      height: 12px;
      top: -6px;
      left: 2px;
    }

    &::after {
      width: 8px;
      height: 8px;
      top: -4px;
      right: 2px;
    }
  }

  &.cloud-2 {
    width: 16px;
    height: 6px;
    top: 30px;
    right: 30px;
    animation-delay: 1.5s;

    &::before {
      width: 10px;
      height: 10px;
      top: -4px;
      left: 1px;
    }

    &::after {
      width: 6px;
      height: 6px;
      top: -3px;
      right: 1px;
    }
  }
}

.sun {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 16px;
  height: 16px;
  background: #ffed4e;
  border-radius: 50%;
  animation: sunGlow 2s ease-in-out infinite alternate;

  &::before {
    content: "";
    position: absolute;
    top: -4px;
    left: -4px;
    right: -4px;
    bottom: -4px;
    border: 2px solid rgba(255, 237, 78, 0.3);
    border-radius: 50%;
  }
}

// SISTEMA DE MEDALHAS COM PROGRESSÃO
.medals-system {
  margin-bottom: 35px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  animation: fadeInUp 1s ease 0.6s both;
}

// MEDALHA DIAMANTE - DESTAQUE PRINCIPAL
.diamond-tier {
  display: flex;
  justify-content: center;
  margin-bottom: 10px;

  .medal-item.premium {
    position: relative;

    &::before {
      content: "★";
      position: absolute;
      top: -15px;
      right: -10px;
      color: #ffd700;
      font-size: 18px;
      z-index: 2;
      animation: starTwinkle 1.5s ease-in-out infinite alternate;
    }
  }
}

.diamond-glow {
  position: relative;

  &::after {
    content: "";
    position: absolute;
    top: -5px;
    left: -5px;
    right: -5px;
    bottom: -5px;
    background: linear-gradient(
      135deg,
      rgba(185, 242, 255, 0.3),
      rgba(224, 248, 255, 0.3)
    );
    border-radius: 50%;
    z-index: -1;
    animation: diamondGlow 2s ease-in-out infinite alternate;
  }
}

.diamond-image {
  width: 70px !important;
  height: 70px !important;
}

.diamond-label {
  font-size: 16px !important;
  color: #fff !important;
  font-weight: 700 !important;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

.medal-subtitle {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  font-style: italic;
  margin-top: 4px;
  display: block;
}

// SETA DE PROGRESSÃO
.progression-arrow {
  display: flex;
  justify-content: center;
  margin: 5px 0;
}

.arrow-up {
  font-size: 24px;
  color: rgba(255, 255, 255, 0.8);
  animation: arrowPulse 1.5s ease-in-out infinite;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
}

// MEDALHAS DE PROGRESSÃO (BRONZE, PRATA, OURO)
.medals-progression {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  position: relative;
  padding: 0 20px;
  min-height: 100px;
}

// CONECTORES ENTRE MEDALHAS
.progression-connector {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  opacity: 0.8;
}

.connector-line {
  width: 30px;
  height: 2px;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0.6),
    rgba(255, 255, 255, 0.9)
  );
  border-radius: 1px;
}

.connector-arrow {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  font-weight: bold;
  animation: connectorPulse 2s ease-in-out infinite;
}

.medal-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;

  &:hover {
    transform: translateY(-5px) scale(1.05);

    .medal-circle {
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
    }
  }
}

// Linhas de progressão antigas - removidas
// Substituídas pelos novos conectores

.medal-circle {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  position: relative;
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  z-index: 2;

  &.diamond {
    width: 90px;
    height: 90px;
    background: linear-gradient(
      135deg,
      rgba(185, 242, 255, 0.95),
      rgba(255, 255, 255, 0.95)
    );
    border: 2px solid rgba(185, 242, 255, 0.3);
  }

  // Animações escalonadas
  &.bronze {
    animation: medalPulse 2s ease-in-out infinite;
    animation-delay: 0s;
  }
  &.silver {
    animation: medalPulse 2s ease-in-out infinite;
    animation-delay: 0.3s;
  }
  &.gold {
    animation: medalPulse 2s ease-in-out infinite;
    animation-delay: 0.6s;
  }
  &.diamond {
    animation: medalPulse 2s ease-in-out infinite,
      diamondSpecial 3s ease-in-out infinite;
    animation-delay: 0.9s, 0s;
  }
}

.medal-image {
  width: 64px;
  height: 64px;
  object-fit: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
  transition: all 0.3s ease;

  .medal-item:hover & {
    filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.2));
    transform: scale(1.1);
  }
}

.medal-label {
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: rgba(255, 255, 255, 0.9);
}

// INDICADOR DE PROGRESSO
.progress-indicator {
  animation: fadeInUp 1s ease 0.8s both;
}

.progress-bar {
  width: 100%;
  height: 6px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
  overflow: hidden;
  margin-bottom: 12px;
}

.progress-fill {
  width: 65%;
  height: 100%;
  background: linear-gradient(90deg, $gold, $gold-light);
  animation: progressGrow 2s ease 1s both;
}

.progress-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
  font-weight: 500;
}

// RESPONSIVIDADE
@media (max-width: 1024px) {
  .login-card {
    max-width: 900px;
  }

  .form-section {
    padding: 40px 30px;
  }

  .illustration-section {
    padding: 40px;
  }
}

@media (max-width: 768px) {
  .modern-login-container {
    padding: 10px;
  }

  .login-card {
    grid-template-columns: 1fr;
    max-width: 500px;
    min-height: auto;
  }

  .form-section {
    padding: 40px 30px;
  }

  // Esconder ilustração em celulares
  .illustration-section {
    display: none;
  }

  .app-title {
    font-size: 24px;
  }
}

@media (max-width: 480px) {
  .form-section {
    padding: 30px 20px;
  }

  .logo-section {
    margin-bottom: 32px;
  }

  .form-content {
    max-width: 100%;
  }

  :deep(.v-btn) {
    padding: 14px 32px !important;
    min-height: 50px !important;
    font-size: 15px !important;
  }

  // Garantir que ilustração continue escondida
  .illustration-section {
    display: none;
  }

  .app-title {
    font-size: 20px;
  }
}

// ANIMAÇÕES
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes buildingGrow {
  from {
    height: 0;
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes cloudFloat {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

@keyframes sunGlow {
  from {
    box-shadow: 0 0 10px rgba(255, 237, 78, 0.5);
  }
  to {
    box-shadow: 0 0 20px rgba(255, 237, 78, 0.8);
  }
}

@keyframes medalPulse {
  0%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

@keyframes progressGrow {
  from {
    width: 0%;
  }
  to {
    width: 65%;
  }
}

@keyframes diamondGlow {
  from {
    opacity: 0.3;
    transform: scale(1);
  }
  to {
    opacity: 0.6;
    transform: scale(1.02);
  }
}

@keyframes diamondSpecial {
  0%,
  100% {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
  50% {
    box-shadow: 0 8px 25px rgba(185, 242, 255, 0.4),
      0 0 30px rgba(185, 242, 255, 0.2);
  }
}

@keyframes starTwinkle {
  from {
    opacity: 0.6;
    transform: scale(1) rotate(0deg);
  }
  to {
    opacity: 1;
    transform: scale(1.1) rotate(15deg);
  }
}

@keyframes arrowPulse {
  0%,
  100% {
    opacity: 0.6;
    transform: translateY(0);
  }
  50% {
    opacity: 1;
    transform: translateY(-3px);
  }
}

@keyframes connectorPulse {
  0%,
  100% {
    opacity: 0.6;
    transform: scale(1);
  }
  50% {
    opacity: 1;
    transform: scale(1.1);
  }
}

// MELHORIAS NO FORMULÁRIO (para integração)
:deep(.v-card) {
  box-shadow: none !important;
  background: transparent !important;
}

:deep(.v-card-text) {
  padding: 0 0 20px 0 !important;
}

:deep(.v-card-actions) {
  padding: 0 0 16px 0 !important;

  &.forgot-password-section {
    padding: 20px !important;
    margin: 24px 0 0 0 !important;
  }
}

:deep(.v-text-field) {
  margin-bottom: 24px;

  &:last-of-type {
    margin-bottom: 32px;
  }
}

:deep(.v-text-field .v-field) {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(42, 79, 215, 0.1);
  transition: all 0.3s ease;
  border: 1px solid rgba(42, 79, 215, 0.15);
  background: white;

  &:hover {
    box-shadow: 0 4px 12px rgba(42, 79, 215, 0.15);
    border-color: rgba(42, 79, 215, 0.25);
  }
}

:deep(.v-text-field .v-field--focused) {
  box-shadow: 0 4px 16px rgba(42, 79, 215, 0.2);
  border-color: $primary-blue;
}

:deep(.v-label) {
  color: $gray-600 !important;
  font-weight: 500 !important;
  font-size: 14px !important;
}

:deep(.v-field__input) {
  color: $gray-700 !important;
  font-size: 16px !important;
  padding: 16px !important;
}

// Estilos específicos para diferentes classes de botão
:deep(.modern-btn-login) {
  background: linear-gradient(
    135deg,
    $primary-blue 0%,
    $primary-blue-light 100%
  ) !important;
  box-shadow: 0 6px 20px rgba(42, 79, 215, 0.3) !important;

  &:hover {
    background: linear-gradient(
      135deg,
      $primary-blue-dark 0%,
      $primary-blue 100%
    ) !important;
  }
}

:deep(.modern-btn-forgot) {
  background: transparent !important;
  border-color: $primary-blue !important;
  color: $primary-blue !important;
}

:deep(.v-btn) {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  padding: 16px 40px !important;
  height: auto !important;
  min-height: 56px !important;
  transition: all 0.3s ease !important;
  font-size: 16px !important;
  letter-spacing: 0.5px !important;

  // Botão principal (ENTRAR)
  &[type="submit"],
  &#btnEntrar {
    background: linear-gradient(
      135deg,
      $primary-blue 0%,
      $primary-blue-light 100%
    ) !important;
    color: white !important;
    box-shadow: 0 6px 20px rgba(42, 79, 215, 0.3) !important;
    width: 100% !important;

    &:hover {
      transform: translateY(-2px) !important;
      box-shadow: 0 8px 25px rgba(42, 79, 215, 0.4) !important;
      background: linear-gradient(
        135deg,
        $primary-blue-dark 0%,
        $primary-blue 100%
      ) !important;
    }

    &:active {
      transform: translateY(0) !important;
    }
  }
}

:deep(.forgot-password-section) {
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%) !important;
  border-radius: 16px !important;
  margin: 24px 0 0 0 !important;
  padding: 20px !important;
  border: 1px solid rgba(42, 79, 215, 0.1) !important;

  .forgot-password-text {
    color: $gray-600 !important;
    font-size: 14px !important;
    font-weight: 500 !important;
    margin-bottom: 16px !important;
  }

  .v-btn {
    background: transparent !important;
    color: $primary-blue !important;
    border: 2px solid $primary-blue !important;
    min-height: 48px !important;
    padding: 12px 32px !important;
    font-weight: 600 !important;
    width: 100% !important;

    &:hover {
      background: $primary-blue !important;
      color: white !important;
      transform: translateY(-1px) !important;
      box-shadow: 0 4px 12px rgba(42, 79, 215, 0.25) !important;
    }
  }
}
</style>
